module.exports = __webpack_public_path__ + "img/sudo-light.b886ecb8.png";